module.exports = __webpack_public_path__ + "static/media/A1-14-Zytrion-X-cod96.3ce32b69.png";